export default __webpack_public_path__ + "images/29c8abc24356f775fb28556a2a1be5e2-home.webp";